<div class="d-flex tw-gap-1 align-items-center">
  <span class="tw-text-xl tw-leading-none" [ngClass]="{'text-secondary': !isRecommended, 'tw-text-black': isRecommended}">
     <mat-icon *ngIf="isShort" matTooltip="Recommended option" matTooltipPosition="above">star_border</mat-icon>
     <mat-icon *ngIf="!isShort">star_border</mat-icon>
  </span>

  <span *ngIf="!isShort" class="tw-truncate" [ngClass]="{'text-secondary': !isRecommended}">
    Recommended <span class="tw-hidden xl:tw-inline">option</span>
  </span>

  <mat-slide-toggle
    data-cy="recommend-option-toggle"
    color="primary"
    class="recommend-option-toggle tw-ml-1"
    [checked]="isRecommended"
    (click)="$event.stopPropagation()"
    (change)="onToggle($event)">
  </mat-slide-toggle>

  <span class="tw-border-l tw-border-lendio-warm-gray-200 tw-h-6"></span>
</div>
